<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerText]="data?.warningTitle"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-circle-info'}"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		{{ data?.warningDescription }}
	</ng-container>

	<ng-container actions>
		@if (!data?.showOnlyConfirmation) {
			<button (click)="close()" class="large" color="warn" mat-raised-button>
				{{ T.BUTTON_CLOSE | translate }}
			</button>
		}

		<button (click)="close({action: 'ok'})" class="large" color="accent" mat-raised-button style="margin-left: 15px">
			{{ data.warningOkText ? data.warningOkText : (T.BUTTON_OK | translate) }}
		</button>
	</ng-container>
</sim-basic-material-dialog>
